import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import NewsTicker from "./NewsTicker";
import FloatingActions from "./FloatingActions";
import EditModeBar from "./live/EditModeBar";
import EnquiryPopup from "./EnquiryPopup";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <NewsTicker />
      <Navbar />
      <main className="flex-1 pt-[80px] mt-9">{children}</main>
      <Footer />
      <FloatingActions />
      <EditModeBar />
      <EnquiryPopup />
    </div>
  );
}
